import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { unregister as unregisterServiceWorker } from './registerServiceWorker'
import './Variables';
import './css/styles.css';
import 'react-image-lightbox/style.css';

ReactDOM.render(<App />, document.getElementById('root'));
unregisterServiceWorker();
